<template>
    <div class="animate-pulse shadow-sm rounded-md max-w-sm">               
        <div class="w-full bg-gray-300 h-96 "></div>
        <div class="flex space-x-3 items-center h-16 justify-center">
            <div class="w-24 bg-gray-300 h-6 rounded-md "></div>
            <div class="w-24 bg-gray-300 h-6 rounded-md "></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'SingleProductSkeleton'
    }
</script>

<style lang="scss" scoped>

</style>